import React from "react";
import _ from "lodash";
import { Accordion } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { getMember, numberFormat } from "../../../actions/miscAction";
import { Link, navigate } from "gatsby";
import Logo from "../../common/logo";

const DashboardSideBar = ({ show, onHide, dashboardCount, onLogOut }) => {
  const member = getMember();
  return (
    <Offcanvas
      className="modal left-collapse fade modal-md mob-offcanvas-pannel-container menu-offcanvas-pannel"
      dialogClassName="modal-dialog "
      contentClassName="modal-content"
      show={show}
      onHide={() => onHide()}
    >
      <Offcanvas.Header className="modal-header d-flex align-items-center sidebar-new">
        {member?.name01 ? (
          <h4>{`Welcome, ${member?.name01}`}</h4>
        ) : (
          <img class="d-block d-lg-none" src={process.env.GATSBY_IMAGE_URL + "logo.svg"} alt="logo" />
        )}
        <div className="btn-close ms-auto" data-bs-dismiss="modal" onClick={() => onHide()}></div>
      </Offcanvas.Header>
      <Offcanvas.Body className="modal-body">
        <div className="menu-offcanvas-list new-accor ">
          <div className="menu-offcanvas-item accordion-item mob-side-items">
            <div className="" onClick={() => navigate("/categories/")}>
              Categories
            </div>
          </div>
          <div className="menu-offcanvas-item accordion-item mob-side-items">
            <div className="" onClick={() => navigate("/regions/")}>
              Regions
            </div>
          </div>
          <div className="menu-offcanvas-item accordion-item mob-side-items">
            <div className="" onClick={() => navigate("/manufacturers/")}>
              Manufacturers
            </div>
          </div>
        </div>
        {member?.name01 ? (
          <Accordion className="menu-offcanvas-list new-accor">
            <Accordion.Item className="menu-offcanvas-item">
              <Link to="/my-account/dashboard/">Dashboard</Link>
            </Accordion.Item>
            <Accordion.Item className="menu-offcanvas-item accordion-item" eventKey="0">
              <Accordion.Button className="accordion-button collapsed" type="button">
                My Account
              </Accordion.Button>
              <Accordion.Body className="accordion-body">
                <ul class="ct-list-mob">
                  <li>
                    <Link to="/my-account/my-profile">
                      <span>My Profile</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/verification">
                      <span>Verification</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/payment-info">
                      <span>Payment Info</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/category-preferences">
                      <span>Category Preferences</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/region-preferences">
                      <span>Region Preferences</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/manufacturer-preferences">
                      <span>Manufacturer Preferences</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/my-account/change-password">
                      <span>Change Password</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/ncnda-list">
                      <span>NCNDA</span>
                    </Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item className="menu-offcanvas-item accordion-item" eventKey="2">
              <Accordion.Button className="accordion-button collapsed" type="button">
                Company
              </Accordion.Button>
              <Accordion.Body className="accordion-body">
                <ul class="ct-list-mob">
                  <li>
                    <Link to="/my-account/business-units">Business Units</Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="menu-offcanvas-item accordion-item" eventKey="1">
              <Accordion.Button className="accordion-button collapsed" type="button">
                Selling
              </Accordion.Button>
              <Accordion.Body className="accordion-body">
                <ul class="ct-list-mob">
                  <li>
                    <Link to="/my-account/pending-and-redeployment">
                      <span>
                        {" "}
                        Pending (
                        {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.pending
                          ? dashboardCount.myBu.pending
                          : "0"}
                        )
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/active-listings">
                      <span>
                        Active (
                        {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.active
                          ? dashboardCount.myBu.active
                          : "0"}
                        )
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/invoiced">
                      <span>
                        Invoiced (
                        {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.invoiced
                          ? dashboardCount.myBu.invoiced
                          : "0"}
                        )
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/archive">
                      <span>
                        Archived (
                        {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.archive
                          ? dashboardCount.myBu.archive
                          : "0"}
                        )
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/my-account/my-sold-listings">
                      <span>
                        {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.success
                          ? dashboardCount.successRate.success
                          : "0"}
                        /
                        {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.total
                          ? dashboardCount.successRate.total
                          : "0"}
                        &nbsp; sold&nbsp;
                        {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.rate
                          ? (
                              parseFloat(dashboardCount.successRate.success / dashboardCount.successRate.total) * 100
                            ).toFixed(2) + "%"
                          : "0%"}
                        &nbsp; success&nbsp;
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/my-buyers">
                      <span>
                        My Buyers ({dashboardCount && dashboardCount.buyerCount ? dashboardCount.buyerCount : 0})
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/seller-listing-agreements">
                      <span>
                        Listing Agreements (
                        {dashboardCount && dashboardCount.listingAgreement ? dashboardCount.listingAgreement : 0})
                      </span>
                    </Link>
                  </li>
                  <li>
                    <a href="/my-account/seller-asset-recovery-report" target="_blank">
                      <span>Asset Recovery Report</span>
                    </a>
                  </li>
                  <li>
                    <a href="/members/post-listing">
                      <span>Create New Listing</span>
                    </a>
                  </li>
                  {dashboardCount?.myActiveListings > 0 && member?.cid >= 1 && (
                    <li>
                      <Link to="/my-account/redeploy-assets">
                        <span>Redeploy Assets</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="menu-offcanvas-item accordion-item" eventKey="3">
              <Accordion.Button className="accordion-button collapsed" type="button">
                Buying
              </Accordion.Button>
              <Accordion.Body className="accordion-body">
                <ul class="ct-list-mob">
                  <li>
                    <Link to="/my-account/current-bids">
                      <span>Current Bids ({dashboardCount && dashboardCount.myBids ? dashboardCount.myBids : 0})</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/watchlist">
                      <span>
                        Watchlist ({dashboardCount && dashboardCount.watchListCount ? dashboardCount.watchListCount : 0}
                        )
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/my-account/invoices">
                      <span>
                        Invoices ({dashboardCount && dashboardCount.totalInvoice ? dashboardCount.totalInvoice : 0})
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/my-questions">
                      <span>
                        My Questions (
                        {dashboardCount && dashboardCount.totalQuestion ? dashboardCount.totalQuestion : 0})
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/my-account/rfq">
                      <span>RFQ ({dashboardCount && dashboardCount.rfqRequest ? dashboardCount.rfqRequest : 0})</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/my-account/procurement-requests">
                      <span>
                        Procurement Requests (
                        {dashboardCount && dashboardCount.procurementRequest ? dashboardCount.procurementRequest : 0})
                      </span>
                    </Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="menu-offcanvas-item">
              <Link to="/my-account/listing-referrals/">
                Listing Referrals (
                {dashboardCount && dashboardCount.buyerActivityCount ? dashboardCount.buyerActivityCount : 0})
              </Link>
            </Accordion.Item>
            <Accordion.Item className="menu-offcanvas-item">
              <a href="javascript:void(0)">
                Credit :{" "}
                {!_.isEmpty(dashboardCount)
                  ? dashboardCount && dashboardCount.credit
                    ? "$" + numberFormat(dashboardCount.credit)
                    : "$0.00"
                  : "$0.00"}
              </a>
            </Accordion.Item>

            {typeof window !== "undefined" &&
              localStorage.getItem("member") &&
              JSON.parse(localStorage.getItem("member")).sec_list == 100103 &&
              !localStorage.getItem("mimictoken") && (
                <Accordion.Item className="menu-offcanvas-item">
                  <Link to="/my-account/mimic-user/">Mimic User</Link>
                </Accordion.Item>
              )}
            <div className="menu-offcanvas-item">
              <a href="javascript:void(0)" onClick={onLogOut}>
                Logout
              </a>
            </div>
          </Accordion>
        ) : (
          <Accordion className="menu-offcanvas-list new-accor">
            <div className="menu-offcanvas-item">
              {member?.name01 ? (
                <a href="javascript:void(0)" onClick={onLogOut}>
                  Logout
                </a>
              ) : (
                <a
                  href="javascript:void(0)"
                  className="header-btn w-100"
                  style={{ padding: "15px" }}
                  onClick={() => navigate("/members/login")}
                >
                  Login/Signup
                </a>
              )}
            </div>
          </Accordion>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DashboardSideBar;
